"use strict";
import moment from "moment";
import { MixPanelAdapter } from "../presentation/adpters/MixPanelAdapter/MixPanelAdapter";
export default [
    "$urlRouterProvider",
    "$locationProvider",
    "$mdDateLocaleProvider",
    ($urlRouterProvider, $locationProvider, $mdDateLocaleProvider) => {
        $locationProvider.html5Mode({ enabled: true, requireBase: true });
        $urlRouterProvider.when("", "/");
        $urlRouterProvider.otherwise("/");
        new MixPanelAdapter().init(publicSettings.mixPanel.token);
        $mdDateLocaleProvider.formatDate = function (date) {
            if (!date) return "";
            return moment(date).format("DD/MM/YYYY");
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            const m = moment(dateString, "DD/MM/YYYY", true);
            return m.isValid() ? m.toDate() : new Date();
        };
    }
];
